export default __webpack_public_path__ + "static/media/premium_hrv.a57da63b.png";